<!--
Author: TangChen
Date: 2018-12-8
Desc: 购买定投基金，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-general-fund bizcomp ' + className">
        <comp-title :title="title" />
        <el-row>
            <el-col v-for="(item, index) in generalWays" :key="index" :span="22" :offset="1">
                <hint-card :data="item" v-on:btn-click="loadPage" />
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import hintCard from "@/components/layout/hintCard.vue";
export default {
    name: "GeneralFund",
    components: {
        hintCard
    },
    mixins: [mixin],
    data() {
        return {
            generalWays: [
                /* { icon: "fa fa-line-chart", tit: "智慧定投", text: "智慧定投是根据指数均线判断市场强弱，并根据判断结果智慧地调整投资金额 ...", cla: "yellow", btnArr: [{ btn: "去定投", page: "wisdombuy" }] }, */
                {
                    icon: "fa fa-pie-chart",
                    tit: "普通定投",
                    text: "固定的时间(如每月1日)以固定的金额(如100元)投资到固定的基金中。",
                    cla: "blue",
                    btnArr: [{ btn: "去定投", page: "glist" }]
                }
                /* { icon: "fa fa-database", tit: "组合定投", text: "组合定投通过资产配置，至少投资两只以上基金，能有效规避定投单只基金可能面临的投资风险...", cla: "green", btnArr: [{ btn: "去定投", page: "combogeneral" }] } */
            ]
        };
    },
    methods: {
        // 加载操作选项页面
        loadPage(url, way) {
            this.$router.push({ name: url });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-general-fund {
    padding: 16px 0 50px;
}
</style>
